import components from "../../../components/ComponentsTabs/components";
import CustomPopup from "../../../images/customPopup/CustomPopup.svg";
import PopupClose from "../../../images/customPopup/PopupClose.svg";
import PopupTrigger from "../../../images/customPopup/PopupTrigger.svg";

export const customPopupBlock = (editor) => {

  const popupRegistry = new Set();

  // Helper: Register popup ID globally
  const registerPopupId = (id) => {
    if (id) popupRegistry.add(id);
  };

  // Component: popup-close-button
  editor.Components.addType("popup-close-button", {
    model: {
      defaults: {
        tagName: "button",
        type: "link",
        components: [
          {
            tagName: "p",
            content: "Close",
            style: {
              margin: '0',
            }
          },
        ],
        attributes: {
          class: "popup-close close",
          'data-close-popup': 'true',
          'data-gjs-highlightable': 'true',
        },
        style: {
          "min-width": "50px",
          "min-height": "50px",
          position: "absolute",
          top: "0px",
          right: "0px",
          border: "none",
          cursor: "pointer",
        },
        traits: [],
      },
    },

  });

  // Component: Custom Popup
  editor.Components.addType("custom-popup", {
    model: {
      defaults: {
        tagName: "div",
        name: "Custom Popup",
        popupId: "popup-1",
        traits: [
          {
            type: "text",
            label: "Popup ID",
            name: "popupId",
            changeProp: 1,
          },
        ],
        attributes: {
          id: "popup-1",
          class: "gjs-popup",
          //  style: "display: block;",
        },
        style: {
          display: "block", // ✅ GrapesJS now controls this
        },
        droppable: false,
        resizable: true,
        hoverable: true,
        selectable: true,
        highlightable: true,
        layerable: true,
        // components: [
        //   {
        //     tagName: "div",
        //     attributes: { class: "popup-overlay" },
        //     droppable: false,
        //     resizable:true,
        components: [
          {
            tagName: "div",
            attributes: { class: "popup-content" },
            resizable: true,
            deletable: false,
            style: {
              width: "300px",
              height: "300px",
              background: "white",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)"
            },
            components: [
              {
                type: "text",
                content: "This is a popup!",
              },
              {
                type: "popup-close-button",
              },

            ],
          },
        ],

        //   },
        // ],
        styles: `
      
          .gjs-popup {
            display: block;
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: none;
            z-index: 9999;
          }
          .popup-overlay {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
          }
          .popup-content {
            background: white;
            padding: 20px;
            border-radius: 8px;
            min-width: 100px;
            box-shadow: 0 0 10px rgba(0,0,0,0.3);
          }
          .popup-close {
            padding: 8px 16px;
            background-color: #dc3545;
            color: #fff;
            border: none;
            border-top-right-radius: 8px;
            border-bottom-left-radius: 8px;
            cursor: pointer;
          }
          .popup-close:hover {
            background-color: #c82333;
          }
        `,
      },
      init() {
        // Listen to removal of inner components
        this.listenTo(this.components(), 'remove', this.onInnerComponentRemoved);

        this.on("change:popupId", () => {
          const id = this.get("popupId");
          this.addAttributes({ id });
          registerPopupId(id);
        });
      },

      onInnerComponentRemoved(removedComponent) {
        const classList = removedComponent.getClasses().map(cls => cls.id || cls);
        if (classList.includes('popup-content')) {
          // Remove this custom-popup component
          this.remove();
        }
      },
    },
  });

  // Block: Popup Modal
  editor.Blocks.add("custom-popup", {
    category: "extra",
    label: "Popup Modal",
    media: `<img src="${CustomPopup}" class="popup-block" title="Pop up" draggable="true" />`,
    // media: `<img src="${LinkBlockIcon}" class="extra-link-block" title="Link Block" draggable="true" />`,
    content: {
      type: "custom-popup",
    },
  });

  // Block: Trigger Button
  editor.Blocks.add("popup-trigger-button", {
    label: "Popup Trigger",
    category: "extra",
    media: `<img src="${PopupTrigger}" class="popup-trigger-block" title="PopUp Trigger" draggable="true" />`,
    //  media: `<img src="${LinkBlockIcon}" class="extra-link-block" title="Link Block" draggable="true" />`,
    content: {
      type: "popup-trigger-button",
    },
  });

  editor.Blocks.add("popup-close-button", {
    label: "Popup Close",
    category: "extra",
    media: `<img src="${PopupClose}" class="popup-close-block" title="PopUp Close" draggable="true" />`,
    //  media: `<img src="${LinkBlockIcon}" class="extra-link-block" title="Link Block" draggable="true" />`,
    content: {
      type: "popup-close-button",
    },
  });
};
